import React, { useEffect } from 'react';
import { getMenuPath, escapeHtml } from '../utils/bannerUtils';

/**
 * 유형 5 - 심플 모던 (배경색 없음, 좁은 높이, 좌측 정렬)
 * 원본: banner-minimal fragment
 *
 * @param {string} title - 페이지 타이틀
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열
 * @param {string} subtitle - 서브타이틀
 */
const BannerMinimal = ({ title, breadcrumbPath, subtitle = '' }) => {
  useEffect(() => {
    // AOS 초기화
    if (typeof window.AOS !== 'undefined') {
      requestAnimationFrame(() => {
        window.AOS.refreshHard();
      });
    }
  }, []);

  const pageTitle = title || '페이지';
  const menuPath = getMenuPath(breadcrumbPath);
  const hasSubtitle = subtitle && subtitle.trim() !== '';

  return (
    <>
      <style>
        {`
          .banner-minimal {
            background: transparent;
            padding: 30px 0 20px;
            border-top: 1px solid #e9ecef;
            border-bottom: 1px solid #e9ecef;
            // background-image: url(/assets/images/page/banner_bg.jpg);
            // background-size: cover;
            // background-position: bottom;
            // text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
          }
          // .banner-minimal *{
          //   color: #ffffff !important;
          // }
          .banner-minimal .container {
            text-align: left;
          }
          .banner-minimal .banner-breadcrumb {
            font-size: 0.85rem;
            color: #6c757d;
            margin-bottom: 12px;
            font-weight: 400;
            letter-spacing: 0.3px;
          }
          .banner-minimal .banner-breadcrumb a {
            color: #6c757d;
            text-decoration: none;
            transition: color 0.2s ease;
          }
          .banner-minimal .banner-breadcrumb a:hover {
            color: var(--theme-color-primary);
            text-decoration: none;
          }
          .banner-minimal .banner-title {
            font-size: 2rem;
            font-weight: 600;
            color: #212529;
            margin-bottom: 8px;
            letter-spacing: -0.5px;
            line-height: 1.3;
          }
          .banner-minimal .banner-subtitle {
            font-size: 0.95rem;
            color: #6c757d;
            margin-top: 8px;
            font-weight: 400;
            line-height: 1.5;
          }
          .banner-minimal .banner-divider {
            display: inline-block;
            width: 40px;
            height: 3px;
            background: var(--theme-color-primary);
            margin-top: 16px;
            border-radius: 2px;
          }
        `}
      </style>
      <div className="banner-minimal">
        <div className="container">
          <div className="banner-breadcrumb" data-aos="fade-right" data-aos-delay="50">
            {menuPath}
          </div>
          <h1 className="banner-title" data-aos="fade-right" data-aos-delay="100">
            {escapeHtml(pageTitle)}
          </h1>
          {hasSubtitle && (
            <p className="banner-subtitle" data-aos="fade-right" data-aos-delay="150">
              {escapeHtml(subtitle)}
            </p>
          )}
          <div className="banner-divider" data-aos="fade-right" data-aos-delay="200"></div>
        </div>
      </div>
    </>
  );
};

export default BannerMinimal;

